module.exports = __webpack_public_path__ + "img/logo.94d52887.svg";